import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_AUTH,
  STORE_STATUS_INITIALIZED,
  STORE_AUTH_VERIFY_ACCESS,
} from 'constants/store'
import {
  createGenericSlice,
  GenericState,
  createReducers,
  ExtraReducers,
} from 'stores/generics'

import { Payload } from 'stores'
import { ErrorStore, VerifyAccess } from '@types'

export type VerifyAccessState = VerifyAccess

type State = GenericState<VerifyAccessState>

export const initialState: State = {
  data: {
    email: null,
    phone: null,
    preRegistered: false, // @deprecated
    exists: false,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchVerifyAccess = createAsyncThunk<
  VerifyAccessState,
  Promise<VerifyAccess>,
  Payload
>(STORE_AUTH_VERIFY_ACCESS, async (promise, { rejectWithValue }) => {
  try {
    return await promise
  } catch (e: unknown) {
    const { code, message } = e as ErrorStore
    return rejectWithValue({ code, message })
  }
})

const extraReducers: ExtraReducers = createReducers<
  VerifyAccessState,
  VerifyAccess,
  Payload
>(fetchVerifyAccess, initialState.data)

const authSlice = createGenericSlice({
  name: STORE_AUTH,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = authSlice

const { clear, success } = actions

export { clear, success }

export default reducer
